<template>
  <div id="introduce-guideline">
    <section ref="HướngDẫnCàiĐặt" id="HướngDẫnCàiĐặt">
      <h4>Hướng Dẫn Cài Đặt Extension Adobe Premiere</h4>
      <div class="content-introduce">
        <p>
          <b
            ><v-icon>{{ mdiChatAlert }}</v-icon
            >Bạn đang đọc tài liệu hướng cài đặt extension Adobe Premiere Pro
          </b>
        </p>
        <p>Có 2 cách để cài đặt Extension Adobe Premiere Pro</p>
        <div>
          <p>
            <b>Cách 1 : Cài đặt trực tiếp từ adobe creative cloud</b>
          </p>
          <p>
            Bước 1 : Tải và cài đặt ứng dụng
            <a
              target="_blank"
              href="https://www.adobe.com/vn_vi/creativecloud/desktop-app.html"
              >Adobe Creative Cloud</a
            >
          </p>
          <p>
            Bước 2: Mở ứng dụng và đăng nhập(Có thể đăng nhập bằng tài khoản
            google) <br />
            Bước 3: Chọn Tab Stock & Makerplace => Plugins => Ở tab Plugin Bên
            Trái filter và search "AI Indexing",Sau khi filter xong sẽ xuất hiện
            Extension như bên dưới
            <img src="../../assets/tutorial/adobe-9.png" />
          </p>
          <p>
            Bước 4: Chọn Get Và OK,Nhận được thông báo như bên dưới là đã cài
            đặt thành công <br />
            <img src="../../assets/tutorial/adobe-10.png" />
          </p>
          <p>
            Bước 5: Mở Adobe Premiere Pro,Chọn Window => Extension => AI
            INDEXING<br />
            <img src="../../assets/tutorial/adobe-11.png" />
          </p>
        </div>

        <div>
          <p>
            <b>Cách 2 : Cài đặt thủ công từ file</b>
          </p>
          <p>
            Bước 1 : Tải và cài đặt ứng dụng
            <a
              target="_blank"
              href="https://www.adobe.com/vn_vi/creativecloud/desktop-app.html"
              >Adobe Creative Cloud</a
            >
            <br />
            Bước 2: Mở ứng dụng và đăng nhập(Có thể đăng nhập bằng tài khoản
            google) <br />
            Bước 3: Tải và cài đặt ứng dụng
            <a target="_Blank" href="https://zxpinstaller.com/"
              >ZXPInstaller
            </a>
            ,chọn bộ cài đặt phù hợp với hệ điều hành <br />
            <a
              href="https://static.vieon.vn/ai-storage/ai_vlz/Plugins/adobe/AIIndeixngV31.zxp"
              >Tải bộ cài extension Adobe Premiere Pro</a
            >
          </p>
          <p>
            Bước 4: Mở Ứng dụng ZXPInstaller,Sau đó chọn hoặc kéo thả file
            extension đã download ở bước 3 <br />
            <img src="../../assets/tutorial/adobe-12.png" />
          </p>
          <p>
            Bước 5: Mở Adobe Premiere Pro,Chọn Window => Extensions => AI
            VISUALIZATION<br />
            <img src="../../assets/tutorial/adobe-11.png" />
          </p>
        </div>
      </div>
    </section>
    <section ref="HướngDẫnSửDụng" id="HướngDẫnSửDụng">
      <h4>Hướng Dẫn Sử Dụng Extension Adobe Premiere</h4>
      <div class="content-introduce">
        <p>
          <b
            ><v-icon>{{ mdiChatAlert }}</v-icon
            >Bạn đang đọc tài liệu hướng dẫn sử dụng extension Adobe Premiere
            Pro
          </b>
        </p>

        <p>
          Sau khi mở Extension,Extension sẽ kiểm tra video input đầu vào có nằm
          trong folder NAS Không, Tiếp Theo,Import Video Cần Edit Vào
          <br /><br />
          <img src="../../assets/tutorial/adobe-1.png" />
        </p>
        <p>
          Sau Khi Import Video,click reload để extension kiểm tra trạng thái của
          Video
        </p>
        <img src="../../assets/tutorial/adobe-2.png" />
        <p>
          Nếu Video Chưa Được hệ thống Indexing,màn hình sẽ Hiển Thị như hình
          bên dưới, Ở đây,chúng ta cần chạy task nhận diện,hiện tại đang hỗ trợ
          3 Model, Nghệ sĩ ,Cảm Xúc,Vật Thể
          <br />
          Click “Chạy Nhận Diện" để tiến hành chạy task
        </p>
        <img src="../../assets/tutorial/adobe-3.png" />
        <p>
          Sau khi chạy task,màn hình sẽ hiển thị các trạng thái của task model
          người dùng vừa chạy
        </p>
        <img src="../../assets/tutorial/adobe-4.png" />
        <p>
          Ở màn hình này,sẽ có 2 button cần lưu ý "Bỏ qua và vào màn hình chính"
          và "Get Certificate"
        </p>
        <p>
          Nếu người dùng chọn button "Bỏ qua và vào màn hình chính",màn hình
          main của extension sẽ xuất hiện
        </p>
        <img src="../../assets/tutorial/adobe-5.png" />
        <p>
          Button "Get Certificate",sử dụng trong trường hợp username datviecvac
          của người dùng bị thay đổi
        </p>
        <img src="../../assets/tutorial/adobe-6.png" />
        <p>ở màn hình Main,chúng ta có thể filter nghệ sĩ chúng ta mong muốn</p>
        <p>
          Ở đây đang lấy ví dụ là 24K.Right đang HAPPY => Click import,tất cả
          data sẽ được đưa xuống thanh timeline của subtitle EBU-Sub
        </p>
        <img src="../../assets/tutorial/adobe-7.png" />
        <p>
          => Click tạo Sequence Mới + Import (Trường hợp này sẽ tạo ra 1
          sequence mới,và cắt tất cả các cảnh có 24K.RIGHT Đang Happy thành
          SubClip nhỏ,và import trực tiếp vào Video Tracks)
        </p>
        <img src="../../assets/tutorial/adobe-8.png" />
      </div>
    </section>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { mdiChatAlert } from "@mdi/js";
export default {
  data() {
    return {
      mdiChatAlert: mdiChatAlert,
      currentSectionId: "",
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    let items = document.getElementById("introduce-guideline")?.childNodes;
    if (items) {
      let ids = Array.prototype.reduce.call(
        items,
        function (arr, elem) {
          arr.push(elem.id);
          return arr;
        },
        []
      );
      this.setListTitle([...ids]);
    }
  },
  beforeDestroy() {
    localStorage.removeItem("myAnchorTilte");
    this.setListTitle([]);
    window.scrollTo(0, 2);
  },
  computed: {
    myAnchorTilte: sync("showcase/myAnchorTilte"),
  },
  methods: {
    setListTitle: call("showcase/setListTitle"),
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const sections = document.getElementById(
        "introduce-guideline"
      ).childNodes;
      let currentSectionIndex = 0;
      for (let i = 0; i < sections.length; i++) {
        const sectionTop = sections[i].offsetTop - 125;
        const sectionBottom = sectionTop + sections[i].offsetHeight;
        if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
          currentSectionIndex = i;
          break;
        }
      }
      const currentSectionId = sections[currentSectionIndex].getAttribute("id");

      if (this.myAnchorTilte !== currentSectionId) {
        this.myAnchorTilte = currentSectionId;
        localStorage.setItem("myAnchorTilte", currentSectionId);
      }
    },
  },
};
</script>

<style lang="scss">
#Introduce {
  ul.circle {
    list-style-type: circle;
  }

  .content-introduce {
    padding: 10px;
    background-color: #f9f9f9;
  }
}
</style>
